export default "__VITE_ASSET__2c253ba9__"